import ProtrackConfirmationModal from './ProtrackConfirmationModal'
import { getFormNames, submit } from 'redux-form/immutable'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { withTranslation } from 'react-i18next'

import { getBlockedPathName } from 'store/entities/protracks/unsavedChanges/selectors'
import { modal } from 'store/entities/modal/actions'

const mapStateToProps = state => ({
  blockedPathname: getBlockedPathName(state),
  formName: getFormNames()(state).get('0'),
})

const mapDispatchToProps = dispatch => ({
  onSave: formName => {
    dispatch(modal.hide())
    dispatch(submit(formName))
  },
  onForceLeave: pathname => {
    dispatch(modal.hide())
    dispatch(push({ pathname, state: { forceLeave: true } }))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('admin')(ProtrackConfirmationModal))
